import { Model } from 'modules/core/lib/mobx-rest'

interface Attributes {
  id: number
  level_id: number
  legal_entities_ids: number[]
  min_range: number
  max_range: number
  currency: string
  salary_frequency: string
  amount_type: 'fixed' | 'range'
}

class JobLevelSalaryRange extends Model<Attributes> {
  static urlRoot() {
    return '/job_catalog/salary_ranges'
  }
}

export default JobLevelSalaryRange
